import {
  WatchtowerPullRequestApiRef,
  WatchtowerPRNeedsReviewApiClient,
} from '@internal/backstage-plugin-pull-requests';
import { ProxyAPIRef, ProxyApiClient } from '@internal/plugin-api-gateway';
import {
  armTagsApiRef,
  ArmTagsClient,
  azureResourcesApiRef,
  AzureResourcesClient,
} from '@internal/plugin-azure-resources-common-react';

import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
  analyticsApiRef,
} from '@backstage/core-plugin-api';
import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';

import { techRadarClientFactory } from './lib/techradar/TechRadarClient';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  techRadarClientFactory,
  createApiFactory({
    api: analyticsApiRef,
    deps: { configApi: configApiRef, identityApi: identityApiRef },
    factory: ({ configApi, identityApi }) =>
      GoogleAnalytics4.fromConfig(configApi, {
        identityApi,
      }),
  }),
  createApiFactory({
    api: WatchtowerPullRequestApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) =>
      new WatchtowerPRNeedsReviewApiClient(discoveryApi, identityApi),
  }),
  createApiFactory({
    api: ProxyAPIRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) =>
      new ProxyApiClient(discoveryApi, identityApi),
  }),
  createApiFactory({
    api: azureResourcesApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => new AzureResourcesClient({ configApi }),
  }),
  createApiFactory({
    api: armTagsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => new ArmTagsClient({ configApi }),
  }),
];
